// extracted by mini-css-extract-plugin
export default {"picture":"Mobilepay_picture__bq7kD"};